import React from 'react';
import { Link } from 'react-router-dom';
import { ThemeToggle } from '@/shared/components/ThemeToggle';
import SupabaseLoginButton from '@/features/auth/components/SupabaseLoginButton';

export const LandingHeader: React.FC = () => {
  return (
    <header className="border-b-2 border-neutral-950 dark:border-neutral-100 sticky top-0 bg-background z-50">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/" className="hidden md:flex flex-col justify-center pl-0 h-10">
                <span className="text-xl font-mono font-black tracking-tighter text-foreground leading-none">
                    [CODII.DEV]
                </span>
                <span className="bg-foreground text-background text-[10px] font-bold px-2 py-0.5 uppercase tracking-wider leading-none mt-1 w-fit font-mono">
                    VERSION 0.61.0
                </span>
            </Link>
          </div>
          <div className="flex items-center gap-6 text-sm font-medium font-mono">
            <Link to="/docs" className="text-muted-foreground hover:text-foreground transition-colors hidden sm:block">
              [DOCS]
            </Link>
            <a href="https://github.com/codii-dev" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors hidden sm:block">
              [GITHUB]
            </a>
            <div className="w-px h-4 bg-neutral-950 dark:bg-neutral-100 hidden sm:block"></div>
            <SupabaseLoginButton
              buttonText="SIGN IN"
              variant="ghost"
              showModal={false}
              className="text-sm h-9 px-4 font-bold tracking-wide hover:bg-neutral-100 dark:hover:bg-neutral-900 rounded-none border border-transparent hover:border-neutral-950 dark:hover:border-neutral-100 transition-all"
            />
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
};
